import { type ReactNode } from 'react';
import { useActiveUiTheme } from '@/hooks/use-active-ui-theme';
import { GlassShell } from './glass/glass-shell';
import { NeonShell } from './neon/neon-shell';
import { InkShell } from './ink/ink-shell';
import { LuxuryShell } from './luxury/luxury-shell';
import { SoftShell } from './soft/soft-shell';
import { RefinedShell } from './refined/refined-shell';
import { WabiShell } from './wabi/wabi-shell';
import { LiquidShell } from './liquid/liquid-shell';

/**
 * 应用 shell 解析器：按当前形态家族（`data-skin`）选择**结构化**布局 shell。
 *
 * 这是「换应用 vs 换皮」的分水岭：
 * - 颜色 → `data-theme` CSS（不变）
 * - 原子控件形态 → `data-skin` CSS（不变）
 * - **布局 shell 的组件树/导航范式/内容几何** → 在此按家族分化（新增第三轴）
 *
 * 未实现的家族回退 {@link GlassShell}（基线），保证任何主题都不崩；后续 P1~P3 逐家族替换。
 */
export function AppShell({ children }: { children: ReactNode }) {
  const { skin } = useActiveUiTheme();

  switch (skin) {
    case 'liquid':
      return <LiquidShell>{children}</LiquidShell>;
    case 'neon':
      return <NeonShell>{children}</NeonShell>;
    case 'ink':
      return <InkShell>{children}</InkShell>;
    case 'luxury':
      return <LuxuryShell>{children}</LuxuryShell>;
    case 'soft':
      return <SoftShell>{children}</SoftShell>;
    case 'refined':
      return <RefinedShell>{children}</RefinedShell>;
    case 'wabi':
      return <WabiShell>{children}</WabiShell>;
    case 'glass':
    default:
      return <GlassShell>{children}</GlassShell>;
  }
}
